// chatbotApi.js — ตัวช่วยเรียก API ของ AI Chatbot (ใช้ร่วมทั้ง ChatbotView และ ChatbotFab)
// ดีไซน์: C:\iStarApp\AI_CHATBOT_DESIGN.md — endpoint ฝั่ง backend อยู่ใน server.js (chatbot.js)
import axios from 'axios';

const authHeader = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export async function sendChatMessage(baseURL, token, { conversationId, text }) {
  const res = await axios.post(`${baseURL}/chatbotMessage`, { conversationId, text }, {
    ...authHeader(token),
    timeout: 185000, // ขา LLM ฝั่ง server ตั้ง 180s — เผื่อ network อีกนิด
  });
  return res.data;
}

export async function listChatConversations(baseURL, token) {
  const res = await axios.get(`${baseURL}/chatbotConversations`, authHeader(token));
  return res.data;
}

export async function getChatConversation(baseURL, token, id) {
  const res = await axios.get(`${baseURL}/chatbotConversation/${id}`, authHeader(token));
  return res.data;
}

export async function deleteChatConversation(baseURL, token, id) {
  const res = await axios.delete(`${baseURL}/chatbotConversation/${id}`, authHeader(token));
  return res.data;
}
